import { useColorMode } from '@chakra-ui/react';
import React from 'react';

import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';
import { Icon } from '~/packages/common-frontend/components/icons';

// Exports
export const ColorModeToggle = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <IconButtonV2
      icon={<Icon icon={colorMode === 'light' ? 'sun-bright' : 'moon'} />}
      aria-label="Color Mode"
      size="sm"
      variant="v2-ghost"
      colorScheme="gray"
      placement="bottom"
      onClick={() => toggleColorMode()}
    />
  );
};
